export default {
  SET_HEADER_TAB_TO_SETTING_OWN: "SET_HEADER_TAB_TO_SETTING_OWN",
  SET_HEADER_TAB_TO_DEFAULT:     "SET_HEADER_TAB_TO_DEFAULT",
  SET_HEADER_TAB_DIAMOND_ICON:   "SET_HEADER_TAB_DIAMOND_ICON",
  SET_HEADER_TAB_SETTING_ICON:   "SET_HEADER_TAB_SETTING_ICON",
  SET_INITIAL_HEADER:            'SET_INITIAL_HEADER',
  SET_BOTH_TAB_ICONE_TRUE:       'SET_BOTH_TAB_ICONE_TRUE',
  SET_PREVIOUS_URL_PATH:         'SET_PREVIOUS_URL_PATH',
  RESET_JOURNEY_PATH:            'RESET_JOURNEY_PATH',
  CHANGE_BACK_CLICK:             'CHANGE_BACK_CLICK',
  SET_HEADER_TAB_TO_STUD:        'SET_HEADER_TAB_TO_STUD',
  SET_HEADER_TAB_TO_STUD_STEP2:  'SET_HEADER_TAB_TO_STUD_STEP2',
  STUD_STEP_1:                   "STEP 1",
  STUD_STEP_2:                   "STEP 2",
}